export function withSocialUtm(
  params: Record<string, string>,
  socialType: string,
) {
  return {
    ...params,
    utm_source: socialType,
    utm_campaign: 'visitorshare',
    utm_medium: 'social',
  };
}
